// Import dependencies
import React from "react";
import Lottie from "lottie-react";

// Import data animation
import GearLottie from "../assets/animation/Gear.json";

// Styles
const style = {
  height: 150,
};

const Gear = () => {
  return (
    <>
      <Lottie style={style} animationData={GearLottie} />
    </>
  );
};

export default Gear;
